import { forwardRef } from 'react';

import classNames from 'classnames';
import { twMerge } from 'tailwind-merge';

type TSelectProps = React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
>;

export const Select = forwardRef<HTMLSelectElement, TSelectProps>(
    ({ className, disabled, ...props }, ref) => {
        return (
            <select
                className={twMerge(
                    classNames(
                        // Override pandora CSS reset
                        'box-border',
                        'rounded-s border border-solid border-structure-80 px-m py-s font-reg placeholder:text-structure-60 focus:outline-primary-40',
                        className
                    )
                )}
                disabled={disabled}
                ref={ref}
                {...props}
            />
        );
    }
);

Select.displayName = 'Select';
